/**
 * Add consistent spacing to comma-separated location labels.
 *
 * @param {string} location
 * @return {string}
 */
export const formatLocationLabel = ( location ) => location
  .split( ',' )
  .map(( part ) => part.trim())
  .filter(( part ) => part.length > 0 )
  .join( ', ' )

/**
 * Find a quick link title by one of its filter values.
 *
 * @param {string} value
 * @param {array} quickLinks
 * @param {string} key
 * @return {string}
 */
export const getQuickLinkTitle = ( value, quickLinks = [], key = 'location' ) => {
  for ( const group of quickLinks ) {
    const links = group.link_group && Array.isArray( group.link_group.links )
      ? group.link_group.links
      : []
    const match = links.find(( link ) => link[ key ] === value )
    if ( match && match.title ) return match.title
  }

  return ''
}

/**
 * Get the best display label for a location filter value.
 *
 * @param {string} location
 * @param {array} quickLinks
 * @return {string}
 */
export const getLocationLabel = ( location, quickLinks = []) => (
  getQuickLinkTitle( location, quickLinks ) || formatLocationLabel( location )
)

/**
 * Get the best display label for a search query value.
 *
 * @param {string} query
 * @param {array} quickLinks
 * @return {string}
 */
export const getSearchLabel = ( query, quickLinks = []) => (
  getQuickLinkTitle( query, quickLinks, 'custom' ) || formatLocationLabel( query )
)
